import { useTheme, Box, Container, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { Fragment, useEffect } from 'react';
import { colorTheme } from 'theme';
import { useNavigate } from 'react-router-dom';

const NotFound = (): JSX.Element => {
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);
  const navigate = useNavigate();

  useEffect(() => {
    // if no credentials => redirect to login
    const credentials = sessionStorage.getItem('credentials');

    if (!credentials) {
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  return (
    <Fragment>
      <Box className="content" sx={{ bgcolor: colors.primaryBg[800] }}>
        <Container
          maxWidth={false}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            overflow: 'hidden',
            overflowY: 'scroll',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box>
            <WarningIcon fontSize="large" />
            <Typography
              component="h1"
              variant="h5"
              fontFamily={['Inter']}
              fontWeight={700}
              fontSize="20px"
            >
              Oops! Your session has expired or you have navigated to a place
              that does not exist.
            </Typography>
            <Typography
              component="h1"
              variant="h5"
              fontFamily={['Inter']}
              fontWeight={700}
              fontSize="28px"
            >
              <a
                style={{ textDecoration: 'none', color: 'blue' }}
                href={`${window.location.origin}/login`}
              >
                Click here
              </a>{' '}
              to be redirected
            </Typography>
          </Box>
        </Container>
      </Box>
    </Fragment>
  );
};

export default NotFound;
